<template>
  <div class="scale">
    <div :style="scaleStyle">
      <ul class="flex justify-between">
        <li
          class="scale-item"
          v-for="(item, index) in issue.labels"
          :key="index"
          @click="onChange(item)"
          :style="getActiveColor(issue.value, index)"
        >
          <div>
            <span>{{ item.num }}</span>
          </div>
        </li>
      </ul>
      <div class="flex justify-between box-border mt-4 text-black text-opacity-85 text-small">
        <span class="mr-2">{{ issue.firstLabel.text }}</span>
        <span class="ml-2">{{ issue.lastLabel.text }}</span>
      </div>
      <div class="unknown-box" key="unknown" v-if="issue.show_unknown">
        <el-radio v-model="issue.value" label="unknown">
          <span>{{ issue.unknown_text }}</span>
        </el-radio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NPSScale',
  changeExpr: 'issue.value',
  computed: {
    scaleStyle() {
      return {
        width: Math.min(this.issue.labels.length * 90, 690) + 'px'
      }
    }
  },
  methods: {
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx)
    },
    onChange(item){
      if(this.view) return
      this.issue.value = item.id
    }
  }
}
</script>
